function getCookie(name) {
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [key, value] = cookie.split('=');
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return null;
}

function deleteCookie(name) {
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=Strict`;
}

// Retrieve the cookies
const orderId = getCookie("order_id");
const name = getCookie("name");
const email = getCookie("email");
const country = getCookie("country");

if (orderId) {
  console.log("Order ID:", orderId);

  // Optionally, delete all the cookies after retrieval:
  deleteCookie("order_id");
  deleteCookie("name");
  deleteCookie("country");

  // Create URL parameters safely using URLSearchParams
  const params = new URLSearchParams();
  params.append("order_id", orderId);
  if (name) {
    params.append("name", name);
  }
  if (email) {
    params.append("email", email);
  }
  if (country) {
    params.append("country", country);
  }

  // Redirect with the encoded parameters
  window.location.href = "https://paysmartltd.com/scotia_live/directspaessentials/?" + params.toString();
} else {
  // Optionally, handle the case when the order_id cookie is not found.
  // console.log("No order_id cookie found.");
}